import { apiFetch } from "./api";

export const getMeetingMetrics = async (quarterly, meetingDate) => {
    const obj = {
        method: 'POST',
        body: {
            option: 'get_meeting_metrics',
            quarterly,
            meetingDate 
        }
    }

    const response = await apiFetch(obj);

    return response;
};
